import React from "react";

export interface ActionButtonProps {
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary";
  disabled?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  type = "button",
  variant = "primary",
  disabled = false,
  icon,
  children,
}) => {
  const className = variant === "primary" ? "action-button" : "action-button-secondary";

  return (
    <button
      type={type}
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      {icon && <span className="button-icon">{icon}</span>}
      <span>{children}</span>
    </button>
  );
};

export default ActionButton;
